const PlusIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="14" stroke="white" strokeWidth="2" />
    <path d="M7.66602 15.5831H24.3327" stroke="white" strokeWidth="2" />
    <path d="M16 24.3333L16 7.66658" stroke="white" strokeWidth="2" />
  </svg>
);

export default PlusIcon;
